
import {
  OnInit,
  Input,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { Documento } from '../models/documento.model';

@Component({
  selector: 'iw-button-download-review',
  template: '<p class="m-0">{{ value }} </p>' +
            '<span *ngIf="radication" class="badge badge-secondary text-light">{{radication}}' +
            '</span>',
  styles: [],
  encapsulation: ViewEncapsulation.None
})
export class InfoRadicationDocComponent implements ViewCell, OnInit {
  // entrada del valor del boton
  @Input() value: any;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: Documento;
  // Contiene el radicado de el documento
  radication = '';

  ngOnInit() {
    if (this.rowData.documentos_detalle.length && this.rowData.documentos_detalle[0].radicado) {
      this.radication = this.rowData.documentos_detalle[0].radicado;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/info-radication-doc.component.ts